import { IncentiveActionType } from '@/types/types';

export const incentiveActionTypesOptions: {
	value: IncentiveActionType;
	label: string;
}[] = [
		{ value: 1, label: 'Upgrade' },
		{ value: 2, label: 'AddOn' },
		{ value: 3, label: 'Information' },
	];

export const frequencyOptions = [
	{ value: 'OneTime', label: 'One time' },
	{ value: 'Weekly', label: 'Weekly' },
	{ value: 'Monthly', label: 'Monthly' },
];
